import DurationHelper from "../../../tools/DurationHelper";
import { IJobResumeDto } from "./IJobResumeDto";
import { JobStatusDto } from "./JobStatusDto";

export default class JobRunDto {

    Id: number;
    Name: string;
    PathId: number;
    PathTypeId: number;
    PathTypeLabel: string;
    PathDeleted: boolean;
    Start: Date;
    End: Date | null;
    Duration: number | null;
    Status: JobStatusDto;
    Progress: number;
    Resume: IJobResumeDto | null;

    constructor(
        id: number,
        name: string,
        pathId: number,
        pathTypeId: number,
        pathTypeLabel: string,
        pathDeleted: boolean,
        start: Date,
        end: Date | null,
        status: JobStatusDto,
        progress: number,
        resume : IJobResumeDto | null
    ) {
        this.Id = id;
        this.Name = name;
        this.PathId = pathId;
        this.PathTypeId = pathTypeId;
        this.PathTypeLabel = pathTypeLabel;
        this.PathDeleted = pathDeleted;
        this.Start = start;
        this.End = end;
        this.Duration = null;
        if (end != null) {
            this.Duration = DurationHelper.SecondsBetween(start, end);
        }
        this.Status = status;
        this.Progress = progress;
        this.Resume = resume;
    }
}
